import React from "react";

import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";

import { styles } from "../styles";

const LABELS = [
  "Тип",
  "Сума",
  "Публічна назва компанії",
  "Юр. назва компанії або ФОП",
  "IBAN",
  "ЄДРПОУ / РНОКПП",
  "Призначення платежу",
  "Дата створення",
  "Термін дії",
  "Нотатка для покупця",
  "Персональна нотатка",
];

const VALUE_WIDTHS = Array.from(
  { length: LABELS.length },
  () => `${Math.floor(Math.random() * 31) + 40}%`,
);

const DetailsSkeleton: React.FC = () => (
  <Box sx={styles.container}>
    {LABELS.map((label, index) => (
      <React.Fragment key={label}>
        <Typography color="grey700">{label}</Typography>
        <Skeleton
          animation="wave"
          variant="text"
          height={24}
          width={VALUE_WIDTHS[index]}
        />
      </React.Fragment>
    ))}
  </Box>
);

export default DetailsSkeleton;
